import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import { RouterContext } from "../Onboarding";

export default function TeamAccessIntro(props) {
  const route = useContext(RouterContext);
  let nextUrl;
  if (props.client_account.website_platform == 0) {
    nextUrl = "/datapulse/onboarding/shopify_access";
  } else {
    nextUrl =
      props.teamAccessChoices && props.teamAccessChoices[0] && props.teamAccessChoices[0] !== "datafeedwatch_install"
        ? `/datapulse/onboarding/${props.teamAccessChoices[0]}`
        : `/datapulse/onboarding/service_agreements_intro`;
  }
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();
  const [validated, setValidated] = useState(false);
  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    const completePages = Object.keys(props.teamAccess).filter((platform) => parseInt(props.teamAccess[platform]["Exist"]) == "1");
    if (completePages.length > 0) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });
  const platforms =

    props.enabled_services.ppc === true && props.enabled_services.seo === true
      ? ["Google Analytics", "Google Ads", "Microsoft Ads", "Google Merchant", "Facebook Ads", "Tiktok Ads", "Youtube", "Google Search Console", "Google Business"]
      : props.enabled_services.ppc === true && props.enabled_services.seo !== true
        ? ["Google Analytics", "Google Ads", "Microsoft Ads", "Google Merchant", "Facebook Ads", "Tiktok Ads", "Youtube"]
        : ["Google Analytics", "Google Search Console", "Google Business"];

  useEffect(() => {
    window.localStorage.setItem(
      "teamChoices",
      JSON.stringify(
        Object.entries(props.teamAccess)
          .filter((el) => el[0] !== "SEMRush")
          .filter((el) => el[1]["Exist"] === "1")
          .map((el) =>
            el[0] === "DataFeedWatch" ? el[0].toLowerCase().replaceAll(" ", "_") + "_install" : el[0].toLowerCase().replaceAll(" ", "_") + "_access"
          )
          .sort()
      )
    );
    props.setTeamAccessChoices(
      Object.entries(props.teamAccess)
        .filter((el) => el[0] !== "SEMRush")
        .filter((el) => el[1]["Exist"] === "1")
        .map((el) => (el[0] === "DataFeedWatch" ? el[0].toLowerCase().replaceAll(" ", "_") + "_install" : el[0].toLowerCase().replaceAll(" ", "_") + "_access"))
        .sort()
    );
  }, [props.teamAccess]);

  // Need to complete pages in progress tracker that do not need to be set up
  const completePages = (pages) => {
    const submitUrl = "/datapulse/onboarding/complete_pages";
    let paramsObject = {
      client_account_id: props.client_account.id,
      pages: pages,
    };
    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: true,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        console.log("Completed pages: " + JSON.stringify(pages));
      },
    });
  };
  const incompletePages = (pages) => {
    const submitUrl = "/datapulse/onboarding/incomplete_pages";
    let paramsObject = {
      client_account_id: props.client_account.id,
      pages: pages,
    };
    $.ajax({
      type: "POST",
      url: submitUrl,
      dataType: "json",
      async: true,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        console.log("Incompleted pages: " + JSON.stringify(pages));
      },
    });
  };
  console.log(
    Object.keys(props.teamAccess).filter(
      (platform) => parseInt(props.teamAccess[platform]["Exist"]) !== 1 && (platform != "SEMRush") & (platform != "DataFeedWatch")
    )
  );
  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col md={7} style={{ maxWidth: "100%" }}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Next Up: Team Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary text-left">
              On this page we'll need to select all of the platforms that the company has accounts with. Then we will go through each of these one at a time on
              the next few pages and provide information and ID's so that the marketing team can do what they do best. Now would be a good opportunity to pause
              and get in touch with anyone who may have this information handy, like company IT specialists and account managers.{" "}
              <strong>
                You can skip and come back to any of the upcoming sections, but we must stress that this may be detrimental to your teams work, and failing to
                provide this information could potentially impede progress and optimal results.
              </strong>
            </p>
          </div>
        </Col>
      </Row>
      <Row className=" pb-3 justify-content-center">
        <Col md={7}>
          <p className="visby-bold py-3 f14 primary">
            Please select the platforms that the company will be utilizing that we either need to set-up OR be given access to:
          </p>
          <Row className="justify-content-center">
            <Col lg={10} xl={7} style={{ maxWidth: "100%" }}>
              <div className="my-3 platform-list">
                {platforms.map((platform, idx) => {
                  return (
                    <div key={idx} className="d-flex pb-2 justify-content-start">
                      <CustomFormCheck
                        id={`ob-team-access-${platform}`}
                        checked={props.teamAccess[platform] ? props.teamAccess[platform]["Exist"] == "1" : false}
                        label={platform}
                        dynamic
                        onChange={(e) => {
                          let accessChecked = props.teamAccess;
                          const currentValue = accessChecked[platform]["Exist"] == "1";
                          accessChecked[platform]["Exist"] = currentValue == "1" ? "0" : "1";
                          props.setTeamAccess({ ...accessChecked });
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <NextButton
              validated={validated}
              btnText={`Let's go`}
              nextPage={nextUrl}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
              onClick={() => {
                let completePagesNames = Object.keys(props.teamAccess).filter(
                  (platform) => parseInt(props.teamAccess[platform]["Exist"]) !== 1 && (platform != "SEMRush") & (platform != "DataFeedWatch")
                );

                !props.seo_section.enabled && completePagesNames.push("SEMRush");
                let incompletePagesNames = Object.keys(props.teamAccess).filter((platform) => parseInt(props.teamAccess[platform]["Exist"]) == 1);
                let pageNames = completePagesNames.map((page) =>
                  page == "DataFeedWatch" ? page.toLowerCase().replaceAll(" ", "_") + "_install" : page.toLowerCase().replaceAll(" ", "_") + "_access"
                );
                let inCompletepageNames = incompletePagesNames.map((page) =>
                  page == "DataFeedWatch" ? page.toLowerCase().replaceAll(" ", "_") + "_install" : page.toLowerCase().replaceAll(" ", "_") + "_access"
                );

                completePages(pageNames.map((page) => `/datapulse/onboarding/${page}`));
                incompletePages(inCompletepageNames.map((page) => `/datapulse/onboarding/${page}`));

                if (props.webPlatform !== 0) {
                  completePages([`shopify_access`, `shopify_authenticate`].map((page) => `/datapulse/onboarding/${page}`));
                } else {
                  incompletePages([`shopify_access`, `shopify_authenticate`].map((page) => `/datapulse/onboarding/${page}`));
                }
              }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
